import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';
import { hasFeature } from '@/lib/utils/features';
import { bootstrapSession } from '@/lib/utils/session';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute('/(client)/inventory')({
  beforeLoad: async () => {
    const user = useSessionStore.getState().user ?? (await bootstrapSession());
    if (!hasFeature(user, 'fiber-forward')) {
      throw redirect({ to: '/dashboard' });
    }

    const perms = await ensurePermissions();
    if (!perms['fiber-forward'].canRead) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: () => <Outlet />,
});
